'use strict';

import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);

import { anchor } from './module/_anchor';
import { modal } from './module/_modal';
import { trailer } from './module/_trailer';
import { nav } from './module/_nav';
import { justHeight } from './module/_justHeight';

const main = (() => {
    /**
     * init
     */
    const init = () => {
        anchor.init();
        modal.init();
        trailer.init();
        nav.init();
        justHeight.init();

        if ($('#home').length > 0) {
            if (isSkip()) {
                $('body').removeClass('is-show-modal');
                $('body').removeClass('is-stop-top');
            }
        }
    };

    /**
     * loaded
     */
    const loaded = () => {
        $('body').addClass('is-loaded');
    };

    /**
     * isSkip
     */
    const isSkip = () => {
        const referrer = document.referrer;
        const domain = document.domain;

        if (referrer.indexOf(domain) > -1) {
            return true;
        } else {
            return false;
        }
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});
